import { GrSchedule } from 'react-icons/gr';
import { Button } from '@chakra-ui/react';

/**
 * Öffnet das PX-Connect-Terminerfassungs-Modal (ADR 0005). Sitzt links neben
 * „Zum Terminplan" und wird nur für PX-Connect-Subprojekte angezeigt — Sichtbarkeit
 * (isPxConnectSource + pxconnect.terminerfassung/create) prüft der Aufrufer.
 *
 * Beschriftung und Icon wie auf Michas Seite „Umbenennungen“ (UCPWO-410); das Icon ist
 * dasselbe wie bei „Zum Terminplan“, damit die beiden Knöpfe als Paar lesbar sind.
 */
export const PxConnectTerminButton = ({ onClick }: { onClick: () => void }) => (
    <Button
        data-test-id="button-pxc-terminerfassung"
        variant="outline"
        rightIcon={<GrSchedule />}
        onClick={onClick}
    >
        PX Terminerfassung
    </Button>
);
